import type { ReactNode } from "react";
import type { UseFormRegisterReturn } from "react-hook-form";
import { Flex, Text } from "styles/utility-components";

import Input from "components/ui/input/Input";
import { localRedirectKind } from "lib/hooks/api/auth/mcp/schemas";
import { ErrorText } from "../sso/SharedStyles";

type Props = {
  registration: UseFormRegisterReturn;
  // The current input value, which picks the note shown for a local callback.
  value: string;
  error?: string;
  hint?: ReactNode;
};

/**
 * The callback URL input, with a note on how the port is matched once the URL is a local one.
 */
export function CallbackUrlField({ registration, value, error, hint }: Props) {
  const localRedirect = localRedirectKind(value);

  return (
    <Flex column gap={6}>
      <label htmlFor="redirectUri">Callback URL</label>
      <Input
        id="redirectUri"
        placeholder="https://example.com/oauth/callback"
        aria-label="Callback URL"
        {...registration}
      />
      {hint && <Text description>{hint}</Text>}
      {error && <ErrorText>{error}</ErrorText>}
      {localRedirect === "any-port" && (
        <Text description>
          Any port works here, so it doesn&apos;t matter if your tool picks a different one each
          time.
        </Text>
      )}
      {localRedirect === "exact-port" && (
        <Text description>
          The port must match exactly. If your tool picks a different port each time, set it up to
          use 127.0.0.1 instead, where any port works.
        </Text>
      )}
    </Flex>
  );
}
